// extracted by mini-css-extract-plugin
module.exports = {"chatAnswerContainer":"ChatAnswer_chatAnswerContainer__XEyZy","chatAnswer":"ChatAnswer_chatAnswer__KqsuN"};